import {
  AllocationWindowRolesParams,
  AllocationWindowsParams,
  FallbackRolesParams
} from "PFCore/services/admin/target_allocation";
import { Id } from "PFTypes";

const ROOT_KEY = "admin_allocation_windows";

export const adminAllocationWindowsKeys = {
  all: () => [ROOT_KEY, "all"],
  fallbackRoles: (params: FallbackRolesParams) => [ROOT_KEY, "fallback_roles", params],
  byPage: ({ page, perPage, sort, termValue }: AllocationWindowsParams) => [
    ...adminAllocationWindowsKeys.all(),
    "byPage",
    perPage,
    page,
    sort,
    termValue
  ],
  single: (allocationWindowId: Id) => [...adminAllocationWindowsKeys.all(), "single", allocationWindowId],
  allRoles: () => [...adminAllocationWindowsKeys.all(), "roles"],
  allFallbackRoles: () => [...adminAllocationWindowsKeys.all(), "fallback_roles"],
  rolesByPage: (params: AllocationWindowRolesParams) => [...adminAllocationWindowsKeys.all(), "roles", params]
};
